export default "__VITE_ASSET__c77861e2__"